import React from 'react';
import { Badge, Box, Chip, useTheme, alpha, keyframes } from '@mui/material';
import { Groups as GroupsIcon } from '@mui/icons-material';
import { useTeamNotifications } from '../hooks/useTeamNotifications';

// تعريف الرسوم المتحركة
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const glow = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgba(255, 0, 0, 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
  }
`;

interface TeamChatNotificationBadgeProps {
  collapsed?: boolean;
}

const TeamChatNotificationBadge: React.FC<TeamChatNotificationBadgeProps> = ({ collapsed = false }) => {
  const theme = useTheme();
  const { unreadCount } = useTeamNotifications();

  if (collapsed) {
    return (
      <Badge
        badgeContent={unreadCount > 0 ? unreadCount : null}
        color="error"
        variant="standard"
        sx={{
          '& .MuiBadge-badge': {
            right: -6,
            top: 6,
            animation: unreadCount > 0 ? `${pulse} 2s infinite, ${glow} 2s infinite` : 'none',
            fontSize: '0.75rem',
            minWidth: 18,
            height: 18,
            borderRadius: '50%',
            boxShadow: `0 2px 8px ${alpha(theme.palette.error.main, 0.4)}`
          }
        }}
      >
        <GroupsIcon />
      </Badge>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Badge
        badgeContent={unreadCount > 0 ? unreadCount : null}
        color="error"
        variant="standard"
        sx={{
          '& .MuiBadge-badge': {
            right: -6,
            top: 6,
            animation: unreadCount > 0 ? `${pulse} 2s infinite, ${glow} 2s infinite` : 'none',
            fontSize: '0.75rem',
            minWidth: 18,
            height: 18,
            borderRadius: '50%',
            boxShadow: `0 2px 8px ${alpha(theme.palette.error.main, 0.4)}`
          }
        }}
      >
        <GroupsIcon />
      </Badge>
      
      {unreadCount > 0 && (
        <Chip
          label={`${unreadCount} جديد`}
          size="small"
          color="error"
          variant="filled"
          sx={{
            height: 20,
            fontSize: '0.7rem',
            fontWeight: 'bold',
            animation: `${pulse} 2s infinite`,
            '& .MuiChip-label': {
              px: 1
            }
          }}
        />
      )}
    </Box>
  );
};

export default TeamChatNotificationBadge;
